/**
 * Safe fetch wrapper that prevents "body stream already read" errors.
 * Clones the response before reading to handle edge cases.
 */
export async function safeFetch(url, options = {}) {
  const response = await fetch(url, options);
  const cloned = response.clone();
  
  let data;
  try {
    data = await response.json();
  } catch {
    try {
      const text = await cloned.text();
      data = JSON.parse(text);
    } catch {
      throw new Error('Server error - please try again');
    }
  }
  
  if (!response.ok) {
    throw new Error(data?.detail || data?.message || `Request failed (${response.status})`);
  }
  
  return data;
}

/**
 * Safe POST request
 */
export async function safePost(url, body) {
  return safeFetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
}

/**
 * Safe PUT request  
 */
export async function safePut(url, body) {
  return safeFetch(url, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
}

/**
 * Safe DELETE request
 */
export async function safeDelete(url, body) {
  return safeFetch(url, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
}
